/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyTriggerInfo {
    getFixupPrototypeFunction() { return PolicyTriggerInfo.fixupPrototype; }

    static newInstance(model: Partial<PolicyTriggerInfo>): PolicyTriggerInfo {
        let obj = Object.assign(new PolicyTriggerInfo(), model);
        PolicyTriggerInfo.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyTriggerInfo>): PolicyTriggerInfo {
        if (!model) return null;
        return PolicyTriggerInfo.newInstance(<PolicyTriggerInfo> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyTriggerInfo) {
        if (!obj) return;

        models.PolicyTriggerInfo.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyTriggerInfo): boolean {
        Object.setPrototypeOf(obj, PolicyTriggerInfo.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * URI of the Policy
     */
    policy_uri: string;

    /**
     * Compliance Ondemand job id
     */
    ondemand_job_id: string;

    /**
     * Policy Parameters, encoded as a JSON string
     */
    args: string;

    instance: Array<string>;

}
